import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
    indicator: {
        padding: '0.2rem',
        borderRadius: '5px',
        marginLeft: '0.5rem',
        backgroundColor: '#000',
        color: '#fff',
        fontSize: '0.9rem',
        fontWeight: 'bold',
    },
}));
